import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { FormikNumericField } from 'components';
import { TranslationNamespace } from 'i18n';

export const P2PProviderPayoutLimits: React.FC = () => {
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'pages.p2p_providers',
  });

  return (
    <Fragment>
      <FormikNumericField
        required
        label={t('fields.payout_limit_count')}
        name="payoutLimits.limitCount"
      />
      <FormikNumericField
        required
        label={t('fields.payout_limit_sum')}
        name="payoutLimits.limitSum"
      />
    </Fragment>
  );
};
